import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setOption, clearOptionsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  options: PropTypes.object,
  error: PropTypes.any,
};

class OptionNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
      },
      option: {
        name: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.option && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Option saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const option = this.state.option;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = option[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.option;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      options: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearOptionsErrors());
    this.props.dispatch(setOption(this.state.option));
  }
  handleCancel() {
    this.props.dispatch(clearOptionsErrors());
    browserHistory.push('/options?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/options?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="option component" style={authPage}>
        <h2>New Option</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.option.name}
              name="name"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.name}
              errorStyle={{ color: cyan500 }}
            />
          </div>
        </div>
      </div>
    );
  }
}

OptionNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionNewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    option: state.options.option,
    error: state.options.error,
  };
}

export default withRouter(connect(mapStateToProps)(OptionNewPage));



// WEBPACK FOOTER //
// ./src/containers/OptionNewPage.js